import React from 'react';
import classNames from 'classnames';
import { array, arrayOf, func, object, string } from 'prop-types';

import IconLocation from '../IconLocation/IconLocation';
import { FieldLocationAutocompleteInput } from '../LocationAutocompleteInput/LocationAutocompleteInput';
import useInterfaceLang from '../../hooks/useInterfaceLang';
import css from './FieldLocationInput.module.css';

const FieldLocationInput = props => {
  const { language } = useInterfaceLang();

  const {
    intl,
    formId,
    fieldClassName,
    countries,
    onChange,
    labelId = 'Global.location',
    placeholderId = 'FieldLocationInput.placeholder',
    name = 'location',
    types,
    ...rest
  } = props;

  return (
    <FieldLocationAutocompleteInput
      rootClassName={fieldClassName}
      inputClassName={classNames(css.input, css.locationInput)}
      iconClassName={css.locationIcon}
      id={formId ? `${formId}.${name}` : name}
      name={name}
      label={intl.formatMessage({
        id: labelId,
      })}
      placeholder={intl.formatMessage({
        id: placeholderId,
      })}
      countries={countries}
      required
      types={types}
      icon={<IconLocation />}
      onChange={onChange}
      language={language}
      {...rest}
    />
  );
};

FieldLocationInput.propTypes = {
  intl: object.isRequired,
  formId: string,
  fieldClassName: string,
  countries: array,
  onChange: func,
  labelId: string,
  placeholderId: string,
  name: string,
  types: arrayOf(string),
};

export default FieldLocationInput;
